import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

// Services and Helpers
import { EmailAlertService } from '../../shared/services/email-alert.service';
import { isValidEmail } from '../../shared/helpers/validation.helper';
import { getErrorMessage } from '../../shared/helpers/error.helper';

@Component({
  selector: 'email-alert',
  templateUrl: './email-alert.component.html',
  styleUrls: ['./email-alert.component.scss']
})
export class EmailAlertComponent implements OnInit {

  // State Properties
  public device_hierarchy: any[] = [];
  public parameters: any[] = [];
  public emailAlerts: any[] = [];
  public selected_device: any | null = null;
  public isLoading: boolean = false;

  // Form Model
  public alertFormModel = {
    selectedParameter: null,
    minVal: '',
    maxVal: '',
    alarmEmail: ''
  };

  // ag-Grid Definitions
  public columnDefs = [
    { headerName: 'Device', field: 'device.location', sortable: true, filter: false, resizable: true },
    { headerName: 'Parameter', field: 'parameter.description', sortable: true, filter: false, resizable: true },
    { headerName: 'Min', field: 'threshold_values.min', sortable: true, filter: false, resizable: true },
    { headerName: 'Max', field: 'threshold_values.max', sortable: true, filter: false, resizable: true },
    { headerName: 'Email', field: 'email', sortable: true, filter: false, resizable: true }
  ];
  public defaultColDef = { sortable: true, filter: false, resizable: true };

  constructor(
    private emailAlertService: EmailAlertService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadInitialData();
  }

  private loadInitialData(): void {
    this.isLoading = true;
    this.emailAlertService.getDeviceLocationHierarchy().subscribe(res => {
      this.device_hierarchy = res.data;
    });
    this.emailAlertService.getEmailAlerts().subscribe(res => {
      this.emailAlerts = res.data;
      this.isLoading = false;
    });
  }

  onDeviceSelect(node: any): void {
    if (node.id) {
      this.selected_device = node;
      this.emailAlertService.getParametersByDeviceId(node.id).subscribe(res => {
        this.parameters = res.data[node.id].parameters;
      });
    }
  }

  // Form submit handler
  onSubmit(): void {
    // 1. Validation
    if (!this.selected_device) {
      this.toastr.error('Please select a device first');
      return;
    }
    if (!this.alertFormModel.selectedParameter) {
      this.toastr.error('Please select a parameter');
      return;
    }
    if (!isValidEmail(this.alertFormModel.alarmEmail)) {
      this.toastr.error('Please enter a valid email address');
      return;
    }
    const min = parseFloat(this.alertFormModel.minVal);
    const max = parseFloat(this.alertFormModel.maxVal);
    if (isNaN(min) || isNaN(max)) {
      this.toastr.error('Min and max values must be numbers');
      return;
    }
    if (min > max) {
      this.toastr.error('Min value must be less than max value');
      return;
    }

    // 2. Payload Creation
    const payload = {
      deviceId: this.selected_device.id,
      parameter: this.alertFormModel.selectedParameter,
      min: this.alertFormModel.minVal,
      max: this.alertFormModel.maxVal,
      email: this.alertFormModel.alarmEmail
    };

    this.isLoading = true;

    // 3. Service Call
    this.emailAlertService.createOrUpdateEmailAlert(payload)
      .pipe(finalize(() => this.isLoading = false)) // isLoading ko false karega, chahe success ho ya error
      .subscribe({
        next: (res) => {
          this.toastr.success(res.data.message || 'Alert updated successfully');
          this.resetForm();
          this.emailAlertService.getEmailAlerts().subscribe(alerts => this.emailAlerts = alerts.data); // Refresh grid
        },
        error: (err) => {
          this.toastr.error(getErrorMessage(err));
        }
      });
  }

  private resetForm(): void {
    this.alertFormModel = {
      selectedParameter: null,
      minVal: '',
      maxVal: '',
      alarmEmail: ''
    };
  }
}